export interface TextSection {
  text: string;
  highlighted: boolean;
}

// TODO: T267853 - add appropriate highlights for text on mid/dark backgrounds, if ever necessary.
export enum HighlightBackground {
  LIGHT = 'light',
  INHERIT = 'inherit',
}
